<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <v-icon size="60" color="primary">domain</v-icon>
                  <h1 class="flex my-4 primary--text">生产及仓储笼</h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" name="login" label="用户名" type="text" v-model="model.username"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="密码" id="password" type="password" v-model="model.password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login" :loading="loading">登录</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import { MsgError } from '@/libs/util';

export default {
  data: () => ({
    loading: false,
    model: {
      username: '',
      password: ''
    }
  }),

  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    login () {
      this.loading = true
      this.handleLogin({
        'userName': this.model.username,
        'password': this.model.password
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo().then(res => {
            this.$router.push('/home')
          })
        } else {
          MsgError('用户名或密码错误')
        }
        this.loading = false;
      }).catch((_) => {
        this.loading = false;
      })
    }
  }

}
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
